enum SearchMatchType {
    All = 0,
    Any = 1,
}

export default SearchMatchType;
